import { Course } from "../../const/types";
import {
  SimpleGrid,
  StackProps,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { useRef } from "react";

interface Props extends StackProps {
  data: Course;
}

export default function ExpandableCourseDescription({ data, ...props }: Props) {
  const { isOpen, onToggle } = useDisclosure();
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <VStack
      align={"stretch"}
      w={"100%"}
      h={isOpen ? "auto" : "200px"}
      borderRadius={12}
      // bg={"var(--divider)"}
      px={2}
      overflow={"hidden"}
      cursor={"pointer"}
      onClick={onToggle}
      transition={"height 0.3s ease-in-out"}
      className={!isOpen ? "halfFade" : ""}
      {...props}
    >
      <Text fontSize={32} fontWeight={700} lineHeight={1.2} mb={2}>
        {data?.nama_course}
      </Text>

      <SimpleGrid columns={[1, null, 2]} gap={5}>
        <VStack align={"stretch"} ref={contentRef}>
          <Text opacity={0.6}>{data?.description}</Text>
        </VStack>

        <VStack align={"stretch"} opacity={0.6}>
          <Text fontWeight={500}>Manfaat</Text>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(data.benefit),
            }}
          />
        </VStack>
      </SimpleGrid>
    </VStack>
  );
}
